import { paint, painting } from '../paint.function.js';
import { processUpdateContext } from '../../tag/processUpdateContext.function.js';
export function updateSupportBy(olderSupport, newerSupport) {
    if (!olderSupport) {
        return;
    }
    const context = olderSupport.context;
    const contexts = context.contexts;
    updateSupportValuesBy(olderSupport, newerSupport);
    ++painting.locks;
    processUpdateContext(olderSupport, contexts);
    --painting.locks;
    paint();
}
function updateSupportValuesBy(olderSupport, newerSupport) {
    const newTemplate = newerSupport.templater;
    const tempTag = newerSupport.templater.tag;
    const values = newTemplate.values || tempTag.values;
    const tag = olderSupport.templater.tag;
    tag.values = values;
}
